<template>
<div class="liuliu">
	<option-header></option-header>
	<div class="header share_center">
		<swiper></swiper>
	  <!-- <div class="banner">
		<swiper></swiper>
	  </div> -->
	</div>
	<router-view/>
</div>
</template>

<script>
import swiper from '@/components/swiper.vue'
import optionHeader from '@/components/optionHeader/index.vue'

export default {
	components:{
		optionHeader,
		swiper
	},
	data() {
		return{
		}
	},
	
	
}
</script>
 
<style lang="scss" scoped>
	.liuliu{
		width: 100%;
		height: 100%;
		background-color: #F9F9F9;
		
		.header{
			width: 100%;
			background:url(../../../public/images/bg.png) no-repeat center center;
			background-size: 100% 5.6rem;
			height: 5.6rem;
			
			.banner{
				height: 100%;
				// width: 62.5%;
				height: 5.6rem;
				margin: 0 auto;
				// background:url(../../../public/images/banner.png) no-repeat center center;
				// background-size: 11rem 4.07rem;
				position: relative;
			}
		}
	}
	// 移动端样式
	@media (max-width:1206px){
		.liuliu{
			width: 100%;
			height: 100%;
			background-color: #F9F9F9;
			
			.header{
				width: 100%;
				height: 3rem;
				// margin-top: 1rem;
				.banner{
					width: 100%;
					height: 3rem;
					// background:url(../../../public/images/banner2.png) no-repeat center center;
					// background-size: 7.5rem 3rem;
				}
			}
		}
	}
</style>